module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bingdao.e14327f3.jpeg";